import { render, staticRenderFns } from "./ShippingModal.vue?vue&type=template&id=04454eab&scoped=true&"
import script from "./ShippingModal.vue?vue&type=script&lang=js&"
export * from "./ShippingModal.vue?vue&type=script&lang=js&"
import style0 from "./ShippingModal.vue?vue&type=style&index=0&id=04454eab&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04454eab",
  null
  
)

export default component.exports